export default [
    {
        path: '/admin/payslip-templates',
        name: 'payslip-template',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/payslip-template/index.vue')
    }
]
